module.exports = __webpack_public_path__ + "static/img/bgs3.062c495.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/bgs3.jpg
// module id = lGIH
// module chunks = 1